var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n-list',{attrs:{"value":"customers","text":"客戶","sortBy":_vm.sortBy,"sortDesc":_vm.sortDesc,"fields":_vm.fields,"items":_vm.customers}})}
var staticRenderFns = []

export { render, staticRenderFns }